interface SummaryRowProps {
  label: string
  value?: string
}

export function SummaryRow({ label, value }: SummaryRowProps) {
  return (
    <div className="flex items-start justify-between gap-3 text-sm">
      <div className="font-medium text-gray-light-700">{label}</div>
      {/* `min-w-0` + `break-words` : une référence de dossier ou un nom long
          poussait la ligne au-delà de l'écran et faisait défiler la page
          entière de côté. */}
      <div className="min-w-0 text-right font-semibold break-words text-gray-light-900">
        {value ?? '-'}
      </div>
    </div>
  )
}
